import { KennoFile } from '@pandiafi/design-system'

export const OTHER_MESSAGE_CATEGORY_VALUE = 'other' as const

export const isOtherMessageCategoryValue = (
  value: unknown
): value is typeof OTHER_MESSAGE_CATEGORY_VALUE =>
  typeof value === 'string' && value === OTHER_MESSAGE_CATEGORY_VALUE

export interface MessageFormValues {
  subject: string
  message: string
  attachments: KennoFile[]
  messageCategoryId: string
}

export const initialValues: MessageFormValues = {
  subject: '',
  message: '',
  attachments: [],
  messageCategoryId: '',
}

export interface Message {
  id: string
  topic: string
  content: string
  date: string
  sender: string
  attachments: {
    fileName: string
    url: string | null
  }[]
  unread: boolean
}

export type RawMessageEntry =
  | {
      type: 'incoming_email_message'
      messageId: number
      title: string
      htmlContent: string
      timestamp: string
      attachments: {
        fileName: string
        url: string | null
      }[]
    }
  | {
      type: 'outgoing_email_message'
      messageId: number
      title: string
      htmlContent: string
      timestamp: string
      isRead: boolean
      attachments: {
        fileName: string
        url: string | null
      }[]
    }

export interface MessageThreadResponse {
  statusCode: number
  payload: {
    entries: RawMessageEntry[]
    title?: string
    logoUrl?: string
  }
}

export interface SendMessageResponse {
  statusCode: number
  payload: {
    messageId: number
  }
}

export interface SendMessageBody {
  subject: string
  htmlContent: string
  fileIds: number[]
  messageThreadUuid: string | undefined
  messageCategoryId?: number | null
}
